export default class BookingModel {
  constructor () {
    this.id = null
    this.reservationId = null
    this.dates = []
    this.price = {
      defaultRate: 0,
      rate: 0,
    }
  }
}
